<section>
  <div class="container">
    <h2>IFC Client Service Specialist</h2>
      <div class="clearfix mb-3"></div>

    <div class="row mb-2">
        <div *ngFor="let clientService of clientServices" class="col-lg-3 col-md-4 col-sm-6">
          <app-advisor-card *ngIf="clientService.id == 69" [data]="clientService"></app-advisor-card>
          <app-css-card *ngIf="clientService.id != 69"[data]="clientService"></app-css-card>
        </div>
    </div>
  </div>
</section>